













import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Mtextarea extends Vue {
  @Prop({ type: String, default: '' })
  title!: string

  @Prop({ type: String, default: '' })
  placeholder!: string

  @Prop({ type: String, default: '' })
  value!: string

  @Prop({ type: Number, default: -1 })
  limit!: number

  @Watch('value')
  watchValue() {
    this.getHight('lczdTxt')
  }

  onChange(e: any) {
    this.$emit('input', e.target.value)
  }

  getHight(refName: any) {
    const textArea: any = this.$refs[refName]
    const scrollHeight = textArea.scrollHeight
    const height = textArea.offsetHeight
    if (height <= scrollHeight) {
      textArea.style.height = 'auto'
      textArea.style.height = textArea.scrollHeight + 'px'
    }
  }
}
